import { axiosConfig } from '../api/axios-config.js'

export const notifyReport = {
  // 取得清單
  get: (id, token, additionalParams = {}) => {
    return axiosConfig.get(`/api/notify-reports/${id || ''}`, { headers: token.headers, params: additionalParams });
  },

  updateStatus: (id, data, token) => axiosConfig.patch(`/api/notify-reports/${id}/status`, data, token),
}
